var LoginURL = 'https://nestoapi.portalonewifi.com/Authentication/';
var BaseURL = 'https://nestoapi.portalonewifi.com/api/Administration/';
var DashboardURL = 'https://nestoapi.portalonewifi.com/api/Dashboard/';
var AnalyticsURL = 'https://nestoapi.portalonewifi.com/api/Analytics/';
var CommonURL = 'https://nestoapi.portalonewifi.com/api/Common/';
var AdministrationURL = 'https://nestoapi.portalonewifi.com/api/Administration/';
var ReportsURL = 'https://nestoapi.portalonewifi.com/api/Reports/';
var LogsURL = 'https://nestoapi.portalonewifi.com/api/Log/';
var MarketingURL = 'https://nestoapi.portalonewifi.com/api/Marketing/';
var ActionAlertURL = 'https://nestoapi.portalonewifi.com/api/ActionAlert/';

export const envConfig = {
  LOGIN_API: `${LoginURL}`,
  ADMIN_API: `${BaseURL}`,
  DASHBOARD_API: `${DashboardURL}`,
  ANALYTICS_API: `${AnalyticsURL}`,
  COMMON_API: `${CommonURL}`,
  ADMINISTRATION_API: `${AdministrationURL}`,
  REPORTS_API: `${ReportsURL}`,
  LOGS_API: `${LogsURL}`,
  MARKETING_API: `${MarketingURL}`,
  ACTION_ALERT_API: `${ActionAlertURL}`,
};